var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysWarning = function SvgSysWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 21a2 2 0 0 1-1.782-2.889l7-14.011a2 2 0 0 1 3.57 0l7 14.011A2 2 0 0 1 19 21H5Zm6.115-16.45-7 14.007A.991.991 0 0 0 5 20h14a.99.99 0 0 0 .89-1.44l-7-14.005a.98.98 0 0 0-.895-.551.971.971 0 0 0-.884.549l.004-.002Zm.39 12.948a.5.5 0 1 1 .308.463.499.499 0 0 1-.313-.461l.005-.002Zm0-2v-5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0Z"
  })));
};
export default SvgSysWarning;